import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      let start, end;

      if (currentPage <= 2) {
        start = 2;
        end = 2;
      } else if (currentPage >= totalPages - 1) {
        start = totalPages - 1;
        end = totalPages - 1;
      } else {
        start = currentPage - 1;
        end = currentPage + 1;
      }

      start = Math.max(2, start);
      end = Math.min(end, totalPages - 1);

      if (currentPage > 3) {
        pages.push("...");
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <nav className="flex justify-center my-8">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 mx-1 border border-primary rounded disabled:opacity-50"
      >
        Prev
      </button>
      {renderPageNumbers().map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && onPageChange(page)}
          className={`px-3 py-1 mx-1 border rounded ${
            currentPage === page ? "bg-primary text-white" : "bg-white"
          } ${page === "..." ? "cursor-default" : ""}`}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 mx-1 border border-primary rounded disabled:opacity-50"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
